import React from 'react'
import styled from '@emotion/styled'
import GlobalCSS from 'src/components/GlobalCSS'
import SEO from 'src/components/seo'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'
import ColorButton from 'src/components/atoms/ColorButton'
import SubPageTopLayout from 'src/components/organisms/SubPageTopLayout'
import Header from 'src/components/organisms/Header'
import Footer from 'src/components/organisms/Footer'
import { Typography } from 'src/components/atoms/Typography'
import { Faq } from 'src/components/organisms/plan/Faq'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { PlanSummary } from 'src/components/organisms/plan/PlanSummary'
import { PlanComparison } from 'src/components/organisms/plan/PlanComparison'
import HeadTitle from 'src/components/atoms/HeadTitle'
import { NoLineBreak } from 'src/components/atoms/NoLineBreak'
import { PlanCustomerSuccessTeam } from 'src/components/organisms/plan/PlanCustomerSuccessTeam'

class Company extends React.Component {
  render() {
    return (
      <>
        <SEO
          title="料金体系"
          description="commmune(コミューン)の料金体系についてご案内致します。"
        />
        <Container>
          <GlobalCSS />
          <Header />
          <SubPageTopLayout title="料金体系" heading="PLAN" />
          <ContentsWrapper>
            <Lead>
              <NoLineBreak inlineIfMobile>
                貴社ニーズやリソース状況に合わせ
              </NoLineBreak>
              <NoLineBreak inlineIfMobile>柔軟な対応が可能です。</NoLineBreak>
              <NoLineBreak inlineIfMobile>
                詳しくはお問い合わせください。
              </NoLineBreak>
            </Lead>
            <PlanSummary />
            <ButtonWrapper>
              <ColorButton
                to="/contact/"
                text="見積もりを問い合わせてみる"
                color="red"
                arrow
              />
            </ButtonWrapper>
          </ContentsWrapper>
          <PlanComparisonWrapper>
            <PlanHeadTitle>サービス・機能比較表</PlanHeadTitle>
            <PlanComparison />
          </PlanComparisonWrapper>
          <ContentsWrapper>
            <PlanCustomerSuccessTeam />
            <Instruction>
              <NoLineBreak inlineIfMobile>
                <NoLineBreak inlineIfMobile>
                  利用人数やサポート内容によって
                </NoLineBreak>
                <NoLineBreak inlineIfMobile>
                  料金体系が変わりますので、
                </NoLineBreak>
              </NoLineBreak>
              <NoLineBreak inlineIfMobile>
                <NoLineBreak inlineIfMobile>
                  具体的なお見積りについては
                </NoLineBreak>
                <NoLineBreak inlineIfMobile>お問い合わせください。</NoLineBreak>
              </NoLineBreak>
            </Instruction>
            <ButtonWrapper>
              <ColorButton
                to="/contact/"
                text="見積もりを問い合わせてみる"
                color="red"
                arrow
              />
            </ButtonWrapper>
          </ContentsWrapper>
          <FaqWrapper>
            <ContentsWrapper>
              <Faq />
            </ContentsWrapper>
          </FaqWrapper>
          <Footer />
        </Container>
      </>
    )
  }
}

const Container = styled.div`
  z-index: 0;
  position: relative;
  overflow: hidden;
`

const Lead = styled(Typography)`
  padding: ${Styles.spacing[11]} ${Styles.spacing[8]};
  line-height: ${Styles.lineHeight[400]};
  letter-spacing: ${Styles.letterSpacing[400]};
  font-size: ${Styles.fontSize[400]};
  @media screen and (min-width: ${BreakPoint.MOBILE}) {
    text-align: center;
  }
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    font-size: ${Styles.fontSize[500]};
    padding: ${Styles.spacing[12]} 0;
    margin: 0 10%;
  }
`

const PlanComparisonWrapper = styled.div`
  margin: ${Styles.spacing[11]} 0;
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    margin: ${Styles.spacing[14]} 0;
  }
`

const PlanHeadTitle = styled(HeadTitle)`
  text-align: center;
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    margin: 0 0 ${Styles.spacing[11]} 0;
  }
`

const ButtonWrapper = styled.div`
  margin: 50px 0 0;
  text-align: center;
  margin: ${Styles.spacing[10]} 0 0;
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    margin: ${Styles.spacing[11]} 0 0;
  }
`

const Instruction = styled(Typography)`
  line-height: ${Styles.lineHeight[400]};
  letter-spacing: ${Styles.letterSpacing[400]};
  font-size: ${Styles.fontSize[300]};
  margin: ${Styles.spacing[11]} ${Styles.spacing[8]};
  text-align: left;
  @media screen and (min-width: ${BreakPoint.MOBILE}) {
    text-align: center;
  }
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    font-size: ${Styles.fontSize[400]};
    margin: ${Styles.spacing[14]} 20% 0;
  }
`

const FaqWrapper = styled.div`
  background: ${Styles.color.grayscale[200]};
  padding: ${Styles.spacing[11]} 0;
  margin: ${Styles.spacing[11]} 0 0;
  @media screen and (min-width: ${BreakPoint.MOBILE}) {
    padding: ${Styles.spacing[14]} 0;
    margin: ${Styles.spacing[14]} 0 0;
  }
`

export default Company
